import { ROUTES } from 'constants/routes.constant';

import { ReactComponent as LeadersIcon } from '../../../../assets/menu/icons/leaders.svg';
import { ReactComponent as NftSwapIcon } from '../../../../assets/menu/icons/nft-swap.svg';
import { ReactComponent as ProfileCollections } from '../../../../assets/profile/icons/profile-collections.svg';
import { ReactComponent as ProfileMarket } from '../../../../assets/profile/icons/profile-market.svg';
import { ReactComponent as ProfileOffers } from '../../../../assets/profile/icons/profile-offers.svg';
import { ReactComponent as VipBadgeIcon } from '../../../../assets/profile/icons/vip-portal.svg';

import MenuAccountDropdownProfileLink from '../menuAccountDropdownProfileLink/MenuAccountDropdownProfileLink';
import styles from './MenuAccountDropdownProfileSection.module.scss';

interface ProfileSectionProps {
  variant?: 'default' | 'referral';
}

const MenuAccountDropdownProfileSection = ({ variant = 'default' }: ProfileSectionProps) => {
  const isReferral = variant === 'referral';
  const listClassNames = [styles['profile-section__list'], isReferral ? styles['profile-section__list--referral'] : '']
    .filter(Boolean)
    .join(' ');

  return (
    <div className={styles['profile-section']}>
      <ul className={listClassNames}>
        <li>
          <MenuAccountDropdownProfileLink to={`${ROUTES.PROFILE}/collected`} variant={variant}>
            <>
              <ProfileCollections className={styles['profile-section__link-icon']} />
              <p>Empire</p>
            </>
          </MenuAccountDropdownProfileLink>
        </li>
        <li>
          <MenuAccountDropdownProfileLink to={`${ROUTES.PROFILE}/listings`} variant={variant}>
            <>
              <ProfileMarket className={styles['profile-section__link-icon']} />
              <p>Listings</p>
            </>
          </MenuAccountDropdownProfileLink>
        </li>
        {/* TODO restore VIP section later
        <li>
          <MenuAccountDropdownProfileLink to={ROUTES.VIP} variant={variant}>
            <>
              <VipBadgeIcon className={`${styles['profile-section__link-icon']} ${styles['profile-section__link-icon--vip']}`} />
              <p>VIP</p>
            </>
          </MenuAccountDropdownProfileLink>
        </li>
        */}
        <li>
          <MenuAccountDropdownProfileLink to={ROUTES.LEADERS} variant={variant}>
            <>
              <LeadersIcon className={styles['profile-section__link-icon']} />
              <p>Leaderboards</p>
            </>
          </MenuAccountDropdownProfileLink>
        </li>
        <li>
          <MenuAccountDropdownProfileLink to={ROUTES.NFT_SWAP} variant={variant}>
            <>
              <NftSwapIcon className={`${styles['profile-section__link-icon']} ${styles['profile-section__link-icon--outline']}`} />
              <p>NFT Swap</p>
            </>
          </MenuAccountDropdownProfileLink>
        </li>
      </ul>
    </div>
  );
};

export default MenuAccountDropdownProfileSection;
